import { SelectItem } from '@/utils/types';

export const HostingRegionHeadRows = [
  {
    id: 'label',
    label: 'Hosting Region',
    sortable: false,
  },
];

export const BillingCategoryHeadRows = [
  {
    id: 'label',
    label: 'Billing Category',
    sortable: false,
  },
];

export const UseCaseHeadRows = [
  {
    id: 'label',
    label: 'Use Case',
    sortable: false,
  },
  {
    id: 'price',
    label: 'TCR Monthly Fee',
    sortable: false,
  },
];

export const ChannelOptions: SelectItem[] = [
  {
    label: '10DLC',
    value: '10DLC',
  },
  {
    label: 'RCS',
    value: 'RCS',
  },
];

export const RcsDisabledChannelOptions: SelectItem[] = [
  {
    label: '10DLC',
    value: '10DLC',
  },
  {
    label: 'RCS',
    value: 'RCS',
    disabled: true,
  },
];
